<template>
  <div>
    <ListKeyword
      :checked="params.checked"
      :conversionType="conversionType"
      :dataType="dataType"
      :items="items"
      :project="project"
      :sort="sort"
      :hasData="hasData"
      :isLoading="isLoading"
      ref="list"
      @check="updateChecked"
      @sort="updateSort"
    />
    <div v-if="params.checked.length">
      <CheckedStatus :count="checkedCount" @reset="resetChecked" />
      <FormAddKeywords
        :count="checkedCount"
        :items="params.checked"
        :project="project"
      />
      <FormAddTasks
        :conversionType="conversionType"
        :count="checkedCount"
        :dataType="dataType"
        :items="params.checked"
        :project="project"
        @reset="resetChecked"
      />
    </div>
  </div>
</template>

<script>
import CheckedStatus from '@/components/siteKeywordAnalysis/CheckedStatus';
import FormAddKeywords from '@/components/siteKeywordAnalysis/FormAddKeywords';
import FormAddTasks from '@/components/siteKeywordAnalysis/FormAddTasks';
import ListKeyword from '@/components/siteKeywordAnalysis/ListKeyword';
import { scroller } from 'vue-scrollto/src/scrollTo';

export default {
  props: {
    conversionType: {
      type: String,
      required: true
    },
    dataType: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    sort: {
      type: Object,
      required: true
    },
    hasData: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    CheckedStatus,
    FormAddKeywords,
    FormAddTasks,
    ListKeyword
  },
  data() {
    return {
      params: {
        checked: []
      },
      scroller: scroller()
    };
  },
  computed: {
    checkedCount() {
      return this.params.checked.length;
    }
  },
  methods: {
    resetChecked() {
      this.params.checked = [];
    },
    scrollTo(item) {
      const list = this.$refs.list;
      const listBottom = list.$el.getBoundingClientRect().bottom;

      // テーブル全体が視界に入っていない時のみテーブルまでスクロールする
      if (listBottom > window.innerHeight) {
        this.scroller(list.$el, 500);
      }
      list.scrollToRow(item);
    },
    updateChecked(checked) {
      this.params.checked = checked;
    },
    updateSort(sort) {
      this.$emit('sort', sort);
    }
  }
};
</script>
